import React from 'react';
import { makeStyles } from '@material-ui/core';
import { FORM_COLORS, SKELETON_OPTIONS } from '../constants';
import { ZoneTabProps } from '../types';
import { LabeledField, SelectInput } from '../components/FormControls';
import { ToggleChips } from '../components/ToggleChips';

const useStyles = makeStyles(() => ({
  previewBox: {
    background: FORM_COLORS.bg,
    borderRadius: 8,
    border: `0.5px solid ${FORM_COLORS.border}`,
    padding: '12px 14px',
    marginTop: 8,
  },
  previewTitle: {
    fontSize: 12,
    color: FORM_COLORS.textSecondary,
    margin: '0 0 10px',
    fontWeight: 500,
  },
  previewRow: {
    display: 'flex',
    gap: 8,
  },
  previewSlot: {
    flex: 1,
    background: FORM_COLORS.white,
    border: `0.5px solid ${FORM_COLORS.border}`,
    borderRadius: 6,
    height: 52,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    color: FORM_COLORS.textSecondary,
  },
  previewSlotActive: {
    background: FORM_COLORS.pinkLight,
    border: `0.5px solid ${FORM_COLORS.pinkMedium}`,
    color: FORM_COLORS.pinkDark,
  },
}));

export const ZoneTab = ({ values, onChange, zoneOptions, loading }: ZoneTabProps) => {
  const classes = useStyles();
  const activePosition = values.skeletonPosition;

  return (
    <div>
      <LabeledField
        label="Zonas / Carruseles"
        required
        hint="Podés asignar el producto a más de una zona."
      >
        <ToggleChips
          options={zoneOptions}
          selected={values.zones}
          onChange={(next) => onChange('zones', next)}
          emptyMessage={loading ? 'Cargando zonas...' : 'No hay zonas disponibles'}
        />
      </LabeledField>

      <LabeledField
        label="Skeleton (posición en home)"
        hint="Solo 3 zonas pueden tener skeleton asignado simultáneamente."
      >
        <SelectInput
          value={values.skeletonPosition}
          onChange={(value) => onChange('skeletonPosition', value)}
          options={SKELETON_OPTIONS}
          style={{ width: 240 }}
        />
      </LabeledField>

      <div className={classes.previewBox}>
        <p className={classes.previewTitle}>Vista previa de posición en carrusel</p>
        <div className={classes.previewRow}>
          {['1', '2', '3'].map((position) => (
            <div
              key={position}
              className={`${classes.previewSlot} ${
                activePosition === position ? classes.previewSlotActive : ''
              }`}
            >
              {activePosition === position ? `Pos. ${position} (asignada)` : `Pos. ${position}`}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
